export class AccessMgmtAssignData {
  userID: number;
  connectPointID: number;
  organizationID: number;
  organizationName: string;
}
